import { Injectable } from '@angular/core';
import { MessageService } from "primeng/primeng";
import { PersistenceService } from "angular-persistence";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import { environment } from '../../environments/environment';
import { ResponseModel } from '../models';
import { SelectModel } from '../models/select.model';
import { Observable } from "rxjs/Observable";
import { SearchCompartmentModel } from '../models/searchCompartment.model';
import { BaseService } from './base.service';
@Injectable()
export class CompartmentsService extends BaseService {
    constructor(protected messageService: MessageService, protected persistenceService: PersistenceService, protected httpClient: HttpClient, private router: Router) {
        super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "Compartments");
    }

    async GetCompartmentByHubId(hubId:any):Promise<ResponseModel>{
        let params=new HttpParams();
        params=params.append("hubId",hubId);
        return super.getCustomApi("GetCompartmentByHubId",params).toPromise();
    }
    
    
    public getCompartmentsByHubId(hubId:any): Observable<ResponseModel> {
        let params = new HttpParams;
        params = params.append("hubId", hubId);
        return super.getCustomApi("GetCompartmentByHubId", params);
    }
    
    async getCompartmentByHubIdAsync(hubId:any): Promise<any[]> {
        const res = await this.getCompartmentsByHubId(hubId).toPromise();
        if (!this.isValidResponse(res)) return;
        const data = res.data as any[];
        return data;
    }

    async getSelectModelCompartmentByHubIdAsync(hubId:any): Promise<SelectModel[]> {
      const data = await this.getCompartmentByHubIdAsync(hubId);
      if (data) {
        let stationHubs: SelectModel[] = [];
        stationHubs.push({ label: `-- Chọn dữ liệu --`, data: null, value: null });
        data.forEach(element => {
          stationHubs.push({
            label: `${element.code} - ${element.name}`,
            data: element,
            value: element.id
          });
        });
        return stationHubs;
      } else {
        return null;
      }
    }

    public searchCompartment(model: SearchCompartmentModel): Observable<ResponseModel> {
      return super.postCustomApi("Search", model);
    }
    
    async searchCompartmentAsync(model: SearchCompartmentModel): Promise<any[]> {
        const res = await this.searchCompartment(model).toPromise();
        if (!this.isValidResponse(res)) return;
        const data = res.data as any[];
        return data;
    }

    public getCompartmentByShelvesId(shelvesId:any): Observable<ResponseModel> {
      let params = new HttpParams;
      params = params.append("shelvesId", shelvesId);
      return super.getCustomApi("GetCompartmentByShelvesId", params);
    }
    
    async getCompartmentByShelvesIdAsync(shelvesId:any): Promise<any[]> {
        const res = await this.getCompartmentByShelvesId(shelvesId).toPromise();
        if (!this.isValidResponse(res)) return;
        const data = res.data as any[];
        return data;
    }
    async getSelectModelCompartmentByShelvesIdAsync(shelvesId:any): Promise<SelectModel[]> {
      const data = await this.getCompartmentByShelvesIdAsync(shelvesId);
      if (data) {
        let stationHubs: SelectModel[] = [];
        stationHubs.push({ label: `-- Chọn dữ liệu --`, data: null, value: null });
        data.forEach(element => {
          stationHubs.push({
            label: `${element.code} - ${element.name}`,
            data: element,
            value: element.id
          });
        });
        return stationHubs;
      } else {
        return null;
      }
    }
}